module.exports = __webpack_public_path__ + "media/images/lb/490-d83993455a3ad28c99c0f7bff60fe33e.svg";